import type { ReactNode } from "react";
import { useUserStore } from "@/lib/userStore.ts";
import { useMsal } from "@azure/msal-react";
import { NeedsInteractionScreen } from "@/auth/NeedsInteractionScreen.tsx";

type AuthGateProps = {
  children: ReactNode;
};

export function AuthGate({ children }: AuthGateProps) {
  const hydrated = useUserStore((s) => s.hydrated);
  const status = useUserStore((s) => s.status);
  const needsInteraction = useUserStore((s) => s.needsInteraction);
  const { inProgress } = useMsal();

  const ready =
    hydrated &&
    inProgress === "none" &&
    status !== "idle" &&
    status !== "loading";

  if (needsInteraction) {
    return <NeedsInteractionScreen />;
  }

  if (!ready) {
    return (
      <main className="min-h-svh flex items-center justify-center">
        <div className="text-sm text-muted-foreground">
          Lade Benutzerinformationen …
        </div>
      </main>
    );
  }

  return <>{children}</>;
}
